module.exports = __webpack_public_path__ + "img/test_img.2fae70ce.png";